var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hideWidth <= _vm.windowWidth)?_c('router-link',{staticClass:"navbar-brand navbar-brand-full",style:(_vm.styleLogo),attrs:{"to":_vm.href}},[_c('b-img',{staticClass:"navbar-brand-image p-2",attrs:{"src":_vm.imageSrc}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }